import { css } from '@emotion/css';

export const QuestionWrapperStyle = css`
    padding: 32px 0;
    display: flex;
    flex-direction: column;
`;

export const ContentStyle = css`
    display: flex;
    flex-direction: column;
    padding: 2rem;
    min-width: 100%;
    max-width: 31.25rem;
    min-height: fit-content;
    box-sizing: border-box;
    * {
        box-sizing: border-box;
    }
`;

export const FieldsetStyle = css`
    border: none;
    padding: 0;
    margin: 0;
`;

export const LegendStyle = css`
    padding-inline-start: 0;
    padding-inline-end: 0;
`;
